import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import HeadingSkeleton from "./../component/HeadingSkeleton";
import $ from "jquery";
import { useLanguage } from "../context/LanguageContext";
import { API_BASE_URL } from "../utils/app_url";
import { useAuth } from "../context/AuthContext";

const deleteIcon = require("./../assets/img/delete-icon3.svg").default;
const editIcon = require("./../assets/img/edit-icon.svg").default;

const Address = () => {
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [allDetails, seAllDetails] = useState();
  const [selectedShipping, setSelectedShipping] = useState();
  const [signupStatus, setSignupStatus] = useState("");
  const [privacyChecked, setPrivacyChecked] = useState(false);

  const fetchShipping = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}users/shipping`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        seAllDetails(responseData.data);
      } else {
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (e, item) => {
    setSelectedShipping(item.id);
    setSignupStatus("");
  };

  const deleteShipping = async id => {
    const confirmDelete = window.confirm(langJson?.areyousureyouwanttodelete);

    if (confirmDelete) {
      try {
        const response = await fetch(`${API_BASE_URL}users/shipping/${id}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          let tempArray = allDetails.filter(item => parseInt(item.id) !== parseInt(id));
          seAllDetails(tempArray);
        } else {
        }
      } catch (error) { }
    }
  };

  const placeOrder = async () => {
    if (!selectedShipping) {
      setSignupStatus(langJson?.pleaseselectoneaddress);
    } else if (!privacyChecked) {
      setSignupStatus(langJson?.pleaseacceptcompanytermsandpolicy);
    } else {
      setLoadingBtn(true);
      sessionStorage.setItem("FFFShippingId", selectedShipping);
      navigate("/payment");
      setLoadingBtn(false);
    }
  };

  useEffect(() => {
    fetchShipping();
  }, []);

  return (
    <div>
      <Header />
      <style>{`body { background: #FFF; }`}</style>
      <div className="mainDiv">
        <div className="mainDiv cartMain">
          <div className="hdnSec topNew">
            {loading ? (
              <HeadingSkeleton width="210px" height="34px" />
            ) : (
              <h2 className="storeTabHdn">{langJson?.selectaddress}</h2>
            )}
            {loading ? (
              <div className="addAddressBtn">
                <div className="skeleton" style={{ width: 110, height: 40, borderRadius: 8 }} />
              </div>
            ) : (
              <div className="addAddressBtn">
                <Link to="/add-address" state={{ from: location.pathname }}>
                  {langJson?.addnew}
                </Link>
              </div>
            )}
          </div>

          {loading ? (
            <>
              <ul className="addressStore">
                {Array.from({ length: 4 }).map((_, index) => (
                  <li key={`address-skeleton-${index}`}>
                    <div className="skeleton" style={{ width: 18, height: 18, borderRadius: 4, marginBottom: 14 }} />
                    <div className="topEdit">
                      <div className="skeleton" style={{ width: 18, height: 18, marginRight: 10 }} />
                      <div className="skeleton" style={{ width: 18, height: 18 }} />
                    </div>
                    <div className="skeleton" style={{ width: "55%", height: 18, marginBottom: 10 }} />
                    <div className="skeleton" style={{ width: "80%", height: 15, marginBottom: 8 }} />
                    <div className="skeleton" style={{ width: "50%", height: 15, marginBottom: 8 }} />
                    <div className="skeleton" style={{ width: "45%", height: 15 }} />
                  </li>
                ))}
              </ul>

              <div className="bottomAddress">
                <div className="skeleton" style={{ width: 360, height: 22, marginBottom: 12 }} />
                <p>
                  <div className="skeleton" style={{ width: 16, height: 16, display: "inline-block", marginRight: 8 }} />
                  <span>
                    <div className="skeleton" style={{ width: "85%", height: 14, marginBottom: 6 }} />
                    <div className="skeleton" style={{ width: "75%", height: 14 }} />
                  </span>
                </p>
                <div className="skeleton" style={{ width: 170, height: 44, borderRadius: 8, marginTop: 10 }} />
              </div>
            </>
          ) : allDetails?.length > 0 ? (
            <>
              <ul className="addressStore addressStoreNew">
                {allDetails?.map((item, index) => (
                  <li key={index}>
                    <input
                      type="radio"
                      name="selectedShippingAddress"
                      checked={Number(selectedShipping) === Number(item?.id)}
                      onChange={e => handleCheckboxChange(e, item)}
                    // onClick={() => {
                    //   setSelectedShipping(item?.id);
                    //   setSignupStatus("");
                    // }}
                    />
<div class="adrressSec">
		{/* <h3>Store 1</h3> */}
                    <h4>{item?.name}</h4>
                    <p>{item?.address}</p>
                    <p>{item?.phone}</p>
                    <p>{item?.city}</p>
</div>
                    <div className="topEdit">
                      <Link to={`/edit-address/${item?.id}`} className="orderBtn">
                        <img src={editIcon} alt="" />
                      </Link>
                      {/* <img src={deleteIcon} alt="" onClick={() => deleteShipping(item?.id)} /> */}
                    </div>
                    
                  </li>
                ))}
              </ul>

              <div className="bottomAddress">
                <h2>
                  {langJson?.desiredpaymentmethod}/{langJson?.requestedpayment}:
                </h2>
                <p>
                  <input type="checkbox" value={privacyChecked} onChange={e => setPrivacyChecked(e.target.checked)} />
                  <span>
                    {langJson?.orderconfirmation_part1} {langJson?.orderconfirmation_part2} {langJson?.orderconfirmation_part3}
                  </span>
                </p>
                {loadingBtn ? <button disabled>{langJson?.confirmorder}</button> : <button onClick={() => placeOrder()}>{langJson?.confirmorder}</button>}
                <span className="lgnStatus">{signupStatus}</span>
              </div>
            </>
          ) : !loading ? (
            <ul className="addressStore">
              <li>
                <h3>{langJson?.norecordsfound}</h3>
              </li>
            </ul>
          ) : null}
        </div>


      </div>
      <Footer />
    </div>
  );
};

export default Address;
